<script>
export default {
    methods: {
        cancel() {
            this.$refs.download.cancel();
            this.$refs.upload.cancel();
            this.$refs.latency.cancel();
            this.cancelled = true;
        },
        async retry() {
            this.$refs.download.reset();
            this.$refs.upload.reset();
            this.$refs.latency.reset();
            this.cancelled = false;
            this.allDone = false;
            this.uploadEnabled = false;
            this.latencyEnable = false;
            this.downloadEnabled = false;
            await this.$nextTick();
            this.downloadEnabled = true;
        }
    },
    data() {
        return {
            downloadEnabled: true,
            uploadEnabled: false,
            latencyEnable: false,
            cancelled: false,
            allDone: false
        }
    },
    props: ['component'],
    translate25Context: 'troubleshooting',
    computed: {
        running() {
            return !this.allDone && !this.cancelled;
        }
    },
    watch: {
    }
};
</script>

<template>
    <div class="troubleshooting-bandwith-container" :class="{'hide-upload' : component.hide_upload}">

        <troubleshooting-bandwith-download ref="download" :enabled="downloadEnabled" :url="component.url"
            @done="component.hide_upload? latencyEnable = true : uploadEnabled = true"></troubleshooting-bandwith-download>

        <troubleshooting-bandwith-upload v-if="!component.hide_upload" ref="upload" :enabled="uploadEnabled" :url="component.url"
            @done="latencyEnable = true"></troubleshooting-bandwith-upload>

        <troubleshooting-bandwith-latency ref="latency" :enabled="latencyEnable"
            :url="component.url" @done="allDone = true"></troubleshooting-bandwith-latency>

        <div class="troubleshooting-bandwith-actions">
            <f-button type="tertiary" @click="cancel()" v-if="running">{{ $vt('Cancel') }}</f-button>
            <f-button type="tertiary" @click="retry()" v-if="allDone || cancelled">{{ $vt('Retry') }}</f-button>
        </div>
    </div>
</template>

<style lang="scss">
.troubleshooting-bandwith-container {
    display: flex;
    gap: 33px;
    flex-wrap: wrap;

    .troubleshooting-bandwith-explanation {
        flex: 0 0 100%;
        margin: 0;
        font-family: Lato;
        font-size: 14px;
        color: #666;
    }

    &.hide-upload  .troubleshooting-bandwith 
    {
        flex: 1 1 50%;
    }

    .troubleshooting-bandwith-latency {
        flex: 1 1 auto
    }

    .troubleshooting-bandwith {
        flex: 1 1 33%;
        display: flex;
        flex-direction: column;

        .troubleshooting-bandwith-title-and-value {
            display: flex;
        }

        .troubleshooting-bandwith-title {
            display: flex;
            gap: 12px;
            font-family: Lato;
            font-size: 20px;
            font-weight: 700;
        }

        .troubleshooting-bandwith-value {
            font-family: Lato;
            font-size: 20px;
            font-weight: 700;
            text-align: right;
            margin-left: auto;
        }

        .troubleshooting-bandwith-chart {
            position: relative;
            margin-top: 20px;
            // margin-left: 20px;
        }

        .troubleshooting-bandwith-chart-y-min
        {
            position: absolute;
            right: 100%;
            bottom: 0;
            white-space: nowrap;
            font-size: 10px;
        }

        .troubleshooting-bandwith-chart-y-max
        {
            position: absolute;
            right: 100%;
            top: 0;
            white-space: nowrap;
            font-size: 10px;
        }

        .troubleshooting-bandwith-legend-container {
            display: flex;
            gap: 12px;
        }

        .troubleshooting-bandwith-annotation {
            position: absolute;
            left: 0;
            width: 100%;
            display: flex;
            flex-direction: column;

            .troubleshooting-bandwith-annotation-line {
                width: 100%;
                border-top: 1px dotted black;
            }

            .troubleshooting-bandwith-annotation-label {
                color: black;
                text-align: right;
            }
        }
    }

    .troubleshooting-bandwith-actions {
        flex: 0 0 100%;
        display: flex;
        gap: 12px;
    }
}

@media (max-width: 500px) {
    .troubleshooting-bandwith-container {

        .troubleshooting-bandwith,
        .troubleshooting-bandwith-latency {
            flex: 0 1 278px;
        }
    }
}
</style>
